window.showBoxError = (msg) => {
  let error = document.getElementById("box-error")
  error.innerHTML = msg
  error.style.display = "block"
}

const valid = () => {
  let emailInput = document.getElementById("site_user_email")
  let passwordInput = document.getElementById("site_user_password")
  let lastNameInput = document.getElementById("site_user_last_name")
  let firstNameInput = document.getElementById("site_user_first_name")
  let nicknameInput = document.getElementById("site_user_nickname")
  let agreeInput = document.getElementById("site_user_agree")
  let email = emailInput.value
  let password = passwordInput.value
  let lastName = lastNameInput.value
  let firstName = firstNameInput.value
  let nickname = nicknameInput.value
  let agree = agreeInput.checked
  if (email == undefined || email == "") { return false }
  if (password == undefined || password == "") { return false }
  if (lastName == undefined || lastName == "") { return false }
  if (firstName == undefined || firstName == "") { return false }
  if (nickname == undefined || nickname == "") { return false }
  if (!agree) { return false }
  return true
}

const signupButtonEnabled = (enabled) => {
  let signupButton = document.getElementById("check-button")
  if (enabled) {
    signupButton.classList.remove("disabled")
    signupButton.disabled = false
    signupButton.classList.add("primary")
  } else {
    signupButton.classList.add("disabled")
    signupButton.disabled = true
    signupButton.classList.remove("primary")
  }
}

let signupButton = document.getElementById("check-button")
signupButton.addEventListener("click", (e) => {
  showLoading()
  document.getElementById("signup-form").submit()
})

for (input of document.getElementsByTagName("input")) {
  input.addEventListener("input", (e) => {
    signupButtonEnabled(valid())
  })
}
